import config from "@/config";

// Store the selected API key for the current session
let sessionApiKey: string | null = null;

/**
 * Gets a random API key from the pool of available keys
 * If there's only one key, it returns that key
 * The selected key is stored for the duration of the session
 */
export const getSessionApiKey = (): string => {
  if (sessionApiKey) {
    return sessionApiKey;
  }

  if (!config.geminiApiKeys) {
    // Fallback to the single API key if the keys array is not defined
    sessionApiKey = config.geminiApiKey;
    return sessionApiKey;
  }

  // Split the comma-separated keys and trim whitespace
  const apiKeys = config.geminiApiKeys.map((key) => key.trim()).filter(Boolean);

  if (apiKeys.length === 0) {
    // Fallback to the single API key if no keys in the array
    sessionApiKey = config.geminiApiKey;
  } else {
    // Select a random key from the pool
    const randomIndex = Math.floor(Math.random() * apiKeys.length);
    sessionApiKey = apiKeys[randomIndex];
    console.log(`Using API key ${randomIndex + 1} of ${apiKeys.length}`);
  }

  return sessionApiKey;
};

/**
 * Resets the session API key, forcing a new selection on the next call
 * Useful for handling API key errors or for testing
 */
export const resetSessionApiKey = (): void => {
  sessionApiKey = null;
};
